import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import { connect } from 'react-redux'
import { push, goBack } from 'react-router-redux'

import './FavoriteTrips.css'
import All from './All'
import Update from './Update'
import New from './New'
import { listFavoriteTrips } from './actions'
import { getFavoritePlace } from '../../models/places'
import onMount from '../../core/onMount'

// List Container methods
// TODO move to its own
const mapStateToProps = (state, ownProps) => {
  return {
    trips: state.models.favorite_trips.map(trip=>({
      ...trip,
      from: `${
          getFavoritePlace(state.models.places, trip.start_place_token).name
        } - ${
          getFavoritePlace(state.models.places, trip.start_place_token).street
        }`,
      to: `${
          getFavoritePlace(state.models.places, trip.end_place_token).name
        } - ${
          getFavoritePlace(state.models.places, trip.end_place_token).street
        }`
    })),
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    onClick: (token_id)=> dispatch(push(`favorite-trips/${token_id}`)),
    dispatch //needed for onMount
  }
}

const ConnectedAll = connect(mapStateToProps, mapDispatchToProps)(
  // onMount(({dispatch}) => dispatch(listFavoriteTrips()) )(All)
  All
)

export default (props)=>
  <div className="FavoriteTrips">
    <Switch>
      <Route exact path={`/account/favorite-trips`} component={ConnectedAll}/>
      <Route path={`/account/favorite-trips/new`} component={New}/>
      <Route path={`/account/favorite-trips/:tripId`} component={Update}/>
    </Switch>
  </div>



// WEBPACK FOOTER //
// ./src/account/favorite-trips/FavoriteTrips.js